import { FormattedMessage } from 'react-intl';
import { CircularProgress, Stack, Typography } from '@rossum/ui/material';

export const InputContentLoader = () => (
  <Stack
    justifyContent="center"
    alignItems="center"
    spacing={2}
    sx={{
      width: 1,
      height: 1,
      backgroundColor: t => t.palette.background.paper,
      borderRight: t => `1px solid ${t.palette.divider}`,
    }}
  >
    <CircularProgress size={40} color="inherit" />
    <Typography>
      <FormattedMessage id="components.editor.inputBox.loading" />
    </Typography>
  </Stack>
);
